<ng-container [formGroup]="model">
  <div>
    <div>
      @if (nameSourceOptions.length > 1) {
        <mat-form-field libZalamoField>
          <mat-label>Źródło nazwy szkoły</mat-label>
          <mat-select formControlName="pickedNameSource">
            @for (option of nameSourceOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.name }}
              </mat-option>
            }
          </mat-select>
          <lib-zalamo-field-decoration></lib-zalamo-field-decoration
        ></mat-form-field>
      }
    </div>
    @if (isSchoolName) {
      <p>
        <lib-button (click)="editSchoolName()">edytuj dane szkoły</lib-button>
      </p>
    }
    Wyrównanie tekstu w poziomie
    <div class="options">
      <lib-button
        [ngClass]="{
          picked: model.value.align === 'left',
        }"
        icon-only
        (click)="
          model.patchValue({
            align: 'left',
          })
        "
      >
        <mat-icon>format_align_left</mat-icon>
      </lib-button>
      <lib-button
        [ngClass]="{
          picked: model.value.align === 'center',
        }"
        icon-only
        (click)="
          model.patchValue({
            align: 'center',
          })
        "
      >
        <mat-icon>format_align_center</mat-icon>
      </lib-button>
      <lib-button
        icon-only
        [ngClass]="{
          picked: model.value.align === 'right',
        }"
        (click)="
          model.patchValue({
            align: 'right',
          })
        "
      >
        <mat-icon>format_align_right</mat-icon>
      </lib-button>
    </div>
    Wyrównanie tekstu w pionie
    <div class="options">
      <lib-button
        [ngClass]="{
          picked: model.value.verticalAlign === 'top',
        }"
        icon-only
        (click)="
          model.patchValue({
            verticalAlign: 'top',
          })
        "
      >
        <mat-icon>align_vertical_top</mat-icon>
      </lib-button>
      <lib-button
        icon-only
        [ngClass]="{
          picked: model.value.verticalAlign === 'center',
        }"
        (click)="
          model.patchValue({
            verticalAlign: 'center',
          })
        "
      >
        <mat-icon> align_vertical_center </mat-icon>
      </lib-button>
      <lib-button
        icon-only
        [ngClass]="{
          picked: model.value.verticalAlign === 'bottom',
        }"
        (click)="
          model.patchValue({
            verticalAlign: 'bottom',
          })
        "
      >
        <mat-icon> align_vertical_bottom </mat-icon>
      </lib-button>
    </div>

    <lib-font-inline-picker formControlName="font"
      >Czcionka:</lib-font-inline-picker
    >
  </div>
  <div class="options">
    Maksymalny rozmiar czcionki
    <div>
      <mat-slider min="10" max="400" step="1" discrete
        ><input matSliderThumb formControlName="fontSize"
      /></mat-slider>
    </div>
  </div>
  <div class="options">
    Odstęp między znakami
    <div>
      <mat-slider min="-1" max="3" step="0.01" discrete
        ><input matSliderThumb formControlName="fontLatterSpacing"
      /></mat-slider>
    </div>
  </div>
  <div class="colorPicker">
    Kolor tekstu:
    <input
      #me
      (colorPickerChange)="model.controls.color.patchValue($event)"
      [(colorPicker)]="model.value.color"
      [style.background]="me.value ? me.value : model.value.color"
      cpPosition="auto"
      [cpUseRootViewContainer]="true"
    />
  </div>
  @if (isGroup) {
    <lib-checkbox formControlName="addYearToGroupName">
      Dodaj rocznik do grupy
    </lib-checkbox>
  }
  <lib-checkbox formControlName="uppercase">
    Tekst wielkimi literami
  </lib-checkbox>
  <mat-form-field libZalamoField>
    <mat-label>Tekst przed</mat-label>
    <input type="text" formControlName="beforeText" matInput />
    <lib-zalamo-field-decoration></lib-zalamo-field-decoration
  ></mat-form-field>
  <mat-form-field libZalamoField>
    <mat-label>Tekst po</mat-label>
    <input type="text" formControlName="afterText" matInput />
    <lib-zalamo-field-decoration></lib-zalamo-field-decoration
  ></mat-form-field>
</ng-container>
